import { Upcs } from '../services/vtoCatalogServices'
import { Product } from '../types/vmdata'
import { imageThumbnailSuffix } from '../app/theme'
import { BrandItem } from '../types/brand'
import { getBrandLogoList } from './utils'

export const formatProduct = (
  products: Upcs[],
  brandList: BrandItem[],
  isDigitalWindow?: boolean
): Product[] => {
  return products.map((product) => {
    const logo = getBrandLogoList(product.brand.name, brandList)
    let logoUrl = logo?.blackLogo || ''

    if (isDigitalWindow && !!logo?.whiteLogo) {
      logoUrl = logo?.whiteLogo
    }

    return {
      upc: product.upc.id,
      code: product.model.code,
      name:
        product.model.code && product.color.code
          ? `${product.model.code} ${product.color.code}`
          : '',
      colorCode: product.color.code || '',
      thumbnailUrl: `${product?.image?.angleUrl}${imageThumbnailSuffix}`,
      brand: {
        name: product.brand.name,
        logoUrl: logoUrl,
      },
      lensColorLabel: product.lens.color || '',
      frameColorLabel: product.frame.color || '',
      styleName: product.style.name || '',
      size: product.sizing.lensBridgeSize || '',
      pictures: product.pictures,
      transitionsSupported: product.transitionsSupported,
      macroAgeRange: product.macroAgeRange || '',
    }
  })
}
